import * as React from 'react'
import Stack from '@mui/material/Stack'
import { ActivitiesButton, ActivitiesContent } from './components'
import { ActivitiesContextProvider } from './context'
import type { ENTITY_TYPES } from '@sales-center/common'

type Props = {
  entityId: number
  entityType: ENTITY_TYPES
  salesTeamId: number
  ownerId: string | null
}

export function ActivitiesManager(props: Props) {
  return (
    <ActivitiesContextProvider>
      <Stack width="fit-content">
        <ActivitiesButton {...props} />
        <ActivitiesContent {...props} />
      </Stack>
    </ActivitiesContextProvider>
  )
}
